<section class="attachment-type-register" *appHasPermission="attachmentTypePermissions.MODULE">
  <div class="attachment-type-register__header">
    <app-breadcrumb [home]="home" [items]="breadcrumbs"></app-breadcrumb>
    <div class="attachment-type-register__header__map d-none">
      <i class="pi pi-map"></i>
    </div>
  </div>
  <div class="attachment-type-register__header">
    <div class="attachment-type-register__header__title">
      <div class="attachment-type-register__header__title__icon" (click)="cancelRegister()">
        <i class="pi pi-arrow-left"></i>
      </div>
      <h1>{{ tk.Management.AttachmentType | t }}</h1>
    </div>
    <div class="attachment-type-register__header__actions">
      <div class="attachment-type-register__header__actions__button">
        <app-button
          [id]="'cancel-register'"
          [label]="tk.User.Cancel | t"
          [type]="'button'"
          [theme]="'white'"
          (sendButtonClick)="cancelRegister()"></app-button>
      </div>
      <div
        class="attachment-type-register__header__actions__button"
        *appHasPermission="attachmentTypePermissions.CREATE">
        <app-button
          [id]="'register-group'"
          [label]="tk.User.Finish | t"
          [type]="'button'"
          [disabled]="attachmentTypeForm.invalid"
          (sendButtonClick)="registerAttachmentType()"></app-button>
      </div>
    </div>
  </div>
  <div class="attachment-type-register__content">
    <form *ngIf="attachmentTypeForm" [formGroup]="attachmentTypeForm" appAutoFormGroup>
      <div class="form-group">
        <div class="row mb-3">
          <div class="col-12 col-sm-6 col-md-6">
            <app-input
              [type]="'text'"
              [placeholder]="'#000000'"
              [controlName]="attachmentTypeRegisterProps.id"
              [label]="tk.Management.Id | t"
              [disabled]="true"
              [required]="false">
            </app-input>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-12 col-md-6">
            <app-input
              [type]="'text'"
              [placeholder]="''"
              [controlName]="attachmentTypeRegisterProps.typeName"
              [label]="tk.Management.Name | t"
              [required]="true"></app-input>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-12">
            <app-input
              [type]="'textarea'"
              [controlName]="attachmentTypeRegisterProps.description"
              [label]="tk.Management.Description | t"
              [required]="false">
            </app-input>
          </div>
        </div>
      </div>
    </form>
  </div>
</section>
